<template>
  <div class="w-full bg-background px-6 py-3">
    <div
      class="flex flex-row items-center justify-start space-x-2"
    >
      <div class="flex flex-col justify-center">
        <p
          class="line-clamp-1 w-9 text-left text-sm font-semibold"
        >
          {{ formattedTime }}
        </p>
      </div>

      <div class="flex min-w-0 flex-1 items-center">
        <span
          class="line-clamp-1 text-xs text-background-fg/70"
        >
          {{ description }}
        </span>
      </div>

      <span
        v-if="!isCashiersEnabled"
        class="inline-flex shrink-0 items-center rounded-full border border-background-fg/20 bg-background-fg/6 px-2 py-px text-[0.625rem] font-semibold uppercase tracking-wide text-background-fg/75"
      >
        Z Report
      </span>

      <p
        class="min-w-12 text-right font-semibold text-background-fg"
      >
        {{ formattedTotal }}
      </p>
    </div>

    <div
      v-if="isCashiersEnabled"
      class="mt-0.5 flex flex-row items-center justify-end"
    >
      <span
        class="inline-flex shrink-0 items-center rounded-full border border-background-fg/20 bg-background-fg/6 px-2 py-px text-[0.625rem] font-semibold uppercase tracking-wide text-background-fg/75"
      >
        Z Report
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TransactionsFeedZReport } from "@/services/orders/listTransactionsFeed"
import type { ListZReportsResponseItem } from "@/services/reconciliation/listZReports"

const { isCashiersEnabled } = useTenant()

const props = defineProps<{
  report: ListZReportsResponseItem | TransactionsFeedZReport
}>()

const formattedTime = computed(() =>
  formatToTime(props.report.createdAt)
)

const { formatToMerchantCurrencyString } = useCurrency()

const formattedTotal = computed(() => {
  if (props.report.totalAmount === null) {
    return "£?"
  }

  return formatToMerchantCurrencyString(
    props.report.totalAmount
  )
})

const description = computed(() => {
  const { fromReceiptNo, toReceiptNo, totalCount } =
    props.report

  if (fromReceiptNo != null && toReceiptNo != null) {
    return `#${fromReceiptNo} - #${toReceiptNo}`
  }

  if (totalCount == null) {
    return "Count unknown"
  } else if (totalCount === 0) {
    return "No transactions"
  } else if (totalCount === 1) {
    return "1 transaction"
  } else {
    return `${totalCount} transactions`
  }
})
</script>
